<template>
<form
  id="app"
  @submit="checkForm"
  action=""
  method="post"
  class="h-100"
  :class="[loading ? 'loading' : '']"
>

    <h2 class="step-title">{{ this.__('trads.Create-your-account') }}</h2>

    <div class="mb-4"></div>

    <template v-if="Object.keys(thirdparty).length > 0">

        <auth-connectors :enabled="thirdparty"/>

        <div class="choose-email">
            <div class="wing"></div>
            <span>{{ this.__('trads.OR') }}</span>
            <div class="wing"></div>
        </div>
    </template>


    <div class="credentials-box" id="register-box">

        <div v-if="Object.keys(errors).length">
            <div 
                class="alert alert-danger" 
                role="alert" 
                v-for="(error, index) in errors" 
                :key="index">
                <strong>{{ error }}</strong>
            </div>
        </div>

        <!--div v-if="Object.keys(errors).length">
            <div class="alert alert-danger" role="alert" v-for="error in errors">
                <strong>{{ error }}</strong>
            </div>
        </div-->

        <span>{{ this.__('trads.Enter-your-email-address') }}</span>
        <input
            type="email"
            v-model="desiredEmail"
            :class="'form-control ' + [errors['email'] ? 'is-invalid' : '']"
            autocomplete="email"
            :placeholder="this.__('trads.Your-email')"
            required autofocus>

        <span>{{ this.__('trads.Create-a-password') }}</span>
        <input
            type="password"
            v-model="desiredPassword"
            name="password"
            class="form-control"
            autocomplete="current-password"
            :placeholder="this.__('trads.Password')"
            required
            />

        <div class="form-check">
            <label class="form-check-label">
                <input type="checkbox" name="newsletter" class="form-check-input" v-model="subscribeNewsletter" />
                <span class="form-check-sign"></span>
                {{ this.__('trads.Yes-send-me-news') }}
            </label>
        </div>

    </div>

    <button type="submit" class="d-flex justify-content-center align-items-center mt-4 btn btn-authent btn-lg btn-block cg-submit">
        {{ this.__('trads.Continue') }}
        <img class="next-arrow" src="/img/style/next-arrow.svg">
    </button>
</form>
</template>

<script>
import Connectors from './Connectors.vue';

export default {
    props: ['email'],
    components: {
        'auth-connectors': Connectors,
    },
    data () {
        return {
            thirdparty: window.thirdparty,
            loading: false,
            errors: {},
            desiredEmail: null,
            desiredPassword: null,
            subscribeNewsletter: null,
        }
    },
    mounted () {
        this.desiredEmail = this.email ? this.email : null;
    },
    methods: {
        checkForm: function(e) {
            this.loading = true;
            this.errors = {};

            axios.post("/api/register/account", {
                email: this.email
            }).then(response => {
                if (response.data && response.data.message) {
                    if (!response.data.message.user_exists) {
                        if (this.$parent.gift) {
                            this.$root.$emit('completedCheckout', true);
                        } else {
                            this.$parent.nextStep();
                        }
                    } else {
                        this.errors['email'] = response.data.message;
                    }
                }
            }).catch(error => {
                this.errors['email'] = error.response.data.message;
                this.loading = false;
            });

            e.preventDefault();
        }
    },
    watch: {
        desiredEmail: function(newEmail) {
            this.$root.$emit('selectedEmail', newEmail);
        },
        desiredPassword: function(newPassword) {
            this.$root.$emit('selectedPassword', newPassword);
        },
        subscribeNewsletter: function(newNewsletter) {
            this.$root.$emit('selectedNewsletter', newNewsletter);
        },
    }
}
</script>

<style>
</style>
